import { Col, Form, Row, Tooltip } from 'antd';
import { FormField } from 'components';
import get from 'lodash/get';
import omit from 'lodash/omit';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setValidity, updateFormField } from 'store/forms/actions';
import { formFields311, formFields312, checkboxes311, formFields3111, formFields3112, formFields3121 } from './formFields';
import { ReactComponent as WhiteInfoButton } from '../../../../../../../assets/icons/whiteInfoButton.svg';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { use } from 'react';
import { isBeneficiary } from 'utils';
import { isNil } from 'lodash';

const SubTabPlan1 = () => {
  const dispatch = useDispatch();
  const excelData = useSelector(state => state.forms?.carrier?.dapanesEpendysis);
  // const businessPlanDetails = excelData ? JSON.parse(excelData) : "";
  const [businessPlanDetails, setBusinessPlanDetails] = useState("");
  const carrier = useSelector(state => state.forms.carrier);
  // console.log("carrier:",carrier);
  // console.log("excelData:",businessPlanDetails);
  // const carrier = useSelector(state => state.forms.carrier)
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  // const viewMode = isViewMode || !isBeneficiary(user.groups);

  useEffect(()=>{
    if(excelData){
      setBusinessPlanDetails(JSON.parse(excelData));
    } else {
      setBusinessPlanDetails("");
    }
  },[excelData]);

  console.log("excelData:",businessPlanDetails);
  const [form] = useForm();

  useEffect(() => {
    form.setFieldsValue({
      investmentFinancingCheckbox: carrier.investmentFinancingCheckbox,
      investmentFinancing: carrier.investmentFinancing,
      otherInvestmentFinancingCheckbox: carrier.otherInvestmentFinancingCheckbox,
      otherInvestmentFinancing: carrier.otherInvestmentFinancing,
    });
  }, [form, carrier]);

  const handleChange = ({ key, type, event }) => {
    // console.log("event:",event.target.checked);
    let newValue;
    if (type === 'text' || type === 'textarea') {
      newValue = event.target.value;
    } else if (type === 'checkbox') {
      newValue = event.target.checked
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    }
    else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals' ||
      type === 'formattedNumber'
    ) {
      newValue = event;
    }
    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  const renderFieldValue1 = field => {
    const value = get(businessPlanDetails.ependutikoSxedio, field.name, '');
    return field.type === 'date' ? (value ? moment(value,"DD/MM/YYYY") : '') : value;
  };

  const renderFieldValue2 = field => {
    const value = get(businessPlanDetails.toposEkteleshs, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : field.name == "topos" ? value?.toUpperCase() : value;
  };

  useEffect(()=>{
    if(businessPlanDetails){
      formFields311.map((field, index) => (form.setFieldValue(field.name,renderFieldValue1(field))));
      formFields3111.map((field, index) => (form.setFieldValue(field.name,renderFieldValue1(field))));
      formFields3112.map((field, index) => (form.setFieldValue(field.name,renderFieldValue1(field))));
      formFields312.map((field, index) => (form.setFieldValue(field.name,renderFieldValue2(field))));
    } else {
      formFields311.map((field, index) => (form.setFieldValue(field.name,"")));
      formFields3111.map((field, index) => (form.setFieldValue(field.name,"")));
      formFields3112.map((field, index) => (form.setFieldValue(field.name,"")));
      formFields312.map((field, index) => (form.setFieldValue(field.name,"")));
    }
  },[businessPlanDetails]);
  
  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    console.log("fieldValue:",value);
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  const renderTooltipTitle = () => {
    return(
      <div style={{display:"inline-grid", justifyContent:"flex-start", justifyItems:"flex-start"}}>
        <span className='bold'>
          Πώς επιλέγονται τα Χρηματοδοτικά Εργαλεία Επένδυσης;
        </span>
        <span>
          Η επιλογή του σωστού χρηματοδοτικού εργαλείου εξαρτάται από τις ανάγκες σας, τους στόχους σας και τη φύση της επένδυσης που θέλετε να υλοποιήσετε.
        </span>
      </div>
    )
  }

  useEffect(() => {
      form.setFieldsValue({
        investmentFinancing: carrier.investmentFinancing,
        investmentFinancingValue: carrier.investmentFinancingValue,
        otherInvestmentFinancing: carrier.otherInvestmentFinancing,
        otherInvestmentFinancingValue: carrier.otherInvestmentFinancingValue,
      });
    }, [form, carrier]);

  useEffect(() => {
    const field311 = Object.values(formFields311).map(field => field.name);
    const field312 = Object.values(formFields312).map(field => field.name);

    form.validateFields(field311.concat(field312)).then(
      () => dispatch(setValidity({ group: 'businessPlan', value: true })),
      () => dispatch(setValidity({ group: 'businessPlan', value: false }))
    );
  }, [carrier]);

  useEffect (() => {

    if (carrier.investmentFinancing == false && !isNil(carrier.investmentFinancingValue)) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'investmentFinancingValue',
          value: null,
        })
      );
      form.setFieldsValue({
        investmentFinancingValue: null,
      });
    }
    if (carrier.otherInvestmentFinancing == false && !isNil(carrier.otherInvestmentFinancingValue)) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'otherInvestmentFinancingValue',
          value: null,
        })
      );
      form.setFieldsValue({
        otherInvestmentFinancingValue: null,
      });
    }

  },[carrier.investmentFinancing, carrier.otherInvestmentFinancing])

  return (
    <div>
      <Form
        form={form}
        initialValues={{

        }}
        trigger="onChange"
      >
        <Row
          // gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          // className="carrier-data-form"

        >
          <div className='d-flex justify-content-between w-100'>
            <Col span={10} className="busPlanCol1">
              <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
                Στοιχεία Επενδυτικού Σχεδίου
              </p>
              <Row
                // gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                // className="carrier-data-form__row"
              >
                {formFields311.map((field, index) => (
                  <Col key={index} className="gutter-row" span={field.span}>
                    <Form.Item
                      name={field.name}
                      value={renderFieldValue1(field)}
                      // initialValue={renderFieldValue1(field)}
                      // initialValues={{
                      //   ...businessPlanDetails.ependutikoSxedio,
                      // }}
                      validateFirst
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                      rules={field.rules}
                    >
                      <FormField
                        {...omit(field, ['span', 'rules'])}
                        key={index}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                ))}
                <div className='d-flex justify-content-between w-100'>
                  {formFields3111.map((field, index) => (
                    <Col key={index} className="gutter-row" span={field.span}>
                      <Form.Item
                        name={field.name}
                        value={renderFieldValue1(field)}
                        validateFirst
                        onChange={value =>
                          handleChange({
                            key: field.name,
                            type: field.type,
                            event: value,
                          })
                        }
                        rules={field.rules}
                      >
                        <FormField
                          {...omit(field, ['span', 'rules'])}
                          key={index}
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ))}
                </div>
                {formFields3112.map((field, index) => (
                  <Col key={index} className="gutter-row" span={field.span}>
                    <Form.Item
                      name={field.name}
                      value={renderFieldValue1(field)}
                      validateFirst
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                      rules={field.rules}
                    >
                      <FormField
                        {...omit(field, ['span', 'rules'])}
                        key={index}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                ))}
              </Row>
            </Col>
            {/* <Col span={3}></Col> */}
            <Col span={11} className="">
            <p className="busPlanSubtitle2">
            &nbsp;
            </p>
              <div
                className="espaFundingWrapper"
                // gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              >
                <Col>
                  <div className="color-white text-bold font-size-18">
                    Χρηματοδοτικά Εργαλεία Επένδυσης
                    <Tooltip
                      // key={infoMessage}
                      // overlayClassName={overlayClassName}
                      title={renderTooltipTitle()}
                    >
                      <WhiteInfoButton style={{marginLeft:"1rem"}}></WhiteInfoButton>
                    </Tooltip>
                  </div>
                  <Row className="mt-2 justify-content-center">
                  {checkboxes311.map((field, index) => (
                    <Col key={`field-${index}`} className="gutter-row" span={field.span}>
                      <Form.Item
                        name={field.name}
                        rules={field.rules}
                        validateFirst
                        valuePropName="checked"
                        checked={renderFieldValue(field)}
                        >
                        <FormField
                          {...omit(field, ['span', 'rules'])}
                          disabled={isViewMode}
                          onChange={value =>
                            handleChange({
                              key: field.name,
                              type: field.type,
                              event: value,
                            })
                          }
                        />
                      </Form.Item>

                      {renderFieldValue(field) == true &&
                        field.financingValue.map((f, i) => (
                          <Form.Item
                            key={`financing-${index}-${i}`}
                            name={f.name}
                            rules={f.rules}
                            validateFirst
                          >
                            <FormField
                              {...omit(f, ['span', 'rules'])}
                              disabled={isViewMode}
                              onChange={value =>
                                handleChange({
                                  key: f.name,
                                  type: f.type,
                                  event: value,
                                })
                              }
                            />
                          </Form.Item>
                        ))}
                    </Col>
                  ))}
                    {/* {checkboxes311.map((checkbox, index) => (
                      <React.Fragment key={index}>
                        <Col span={24}>
                          <Form.Item
                            name={checkbox.name}
                            valuePropName="checked"
                            validateFirst
                            checked={renderFieldValue(checkbox)}
                            onChange={event =>
                              handleChange({
                                key: event.target.name,
                                value: event.target.checked,
                                type: 'checkbox',
                              })
                            }
                            rules={checkbox.rules}
                          >
                            <FormField
                              {...checkbox}
                              disabled={false}
                              type="checkbox"
                            />
                          </Form.Item>
                        </Col>  
                      </React.Fragment>
                    ))} */}
                  </Row>
                </Col>
              </div>
              <p className=" mr-0 color-blue-3 text-bold font-size-24">
                Τόπος Εκτέλεσης Επενδυτικού Σχεδίου
              </p>
              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                // className="carrier-data-form__row"
              >
                {formFields312.map((field, index) => (
                  <Col key={index} className="gutter-row" span={field.span}>
                    <Form.Item
                      name={field.name}
                      value={renderFieldValue2(field)}
                      validateFirst
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                      rules={field.rules}
                    >
                      <FormField
                        {...omit(field, ['span', 'rules'])}
                        key={index}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                ))}
              </Row>
            </Col>
          </div>
        </Row>
      </Form>
    </div>
  );
};

export default SubTabPlan1;
